/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCsmProfile.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/planning/csm/csm-profile";

export class AutogenModelCsmProfile<RowType extends ModelRow> extends Endpoint<RowType, RowCsmProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCsmProfile extends ModelRow<RowCsmProfileFields> {
	constructor(values?: Partial<RowCsmProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCsmProfileFields {
	appt_status: string;
	auth_status: string;
	brokerage_status: string;
	company_id: string;
	default_view: string;
	descr: string;
	display_until_ready_to_bill: string;
	entry_user: string;
	exclude_appt_status: string;
	exclude_auth_status: string;
	exclude_brokerage_status: string;
	exclude_company: string;
	exclude_customer: string;
	exclude_entry_user: string;
	exclude_inbound: string;
	exclude_move_status: string;
	exclude_movement_type: string;
	exclude_operations_user: string;
	exclude_order_status: string;
	exclude_order_type: string;
	exclude_osd_status: string;
	exclude_outbound: string;
	exclude_revenue_code: string;
	id: string;
	include_on_hold_orders: string;
	include_tabs: string;
	missing_appts_only: string;
	move_status: string;
	movement_type: string;
	operations_user: string;
	order_company: string;
	order_customers: string;
    commodity: string;
	order_gridconfig: string;
	order_ib_list: string;
	order_ib_type: string;
	order_late_only: string;
	order_ob_list: string;
	order_ob_type: string;
	order_status: string;
	order_type_id: string;
	order_unrated_only: string;
	orders_days: number;
	osd_status: string;
	preassigned_order: string;
	profile_color: string;
	revenue_code: string;
	service_incident_only: string;
	show_ltl_orders: string;
	start_day: string;
	subject_loads: string;
	tab_in_focus: string;
}

